import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { getBestThumbnail } from '../../service/helpers';
import { RootState } from '../../store/root-reducer';

const ImagesPreloader: React.FC<{ urls: string[] }> = ({ urls }) => {
  useEffect(() => {
    if (process.browser) {
      setTimeout(() => {
        urls.map((url) => {
          const img = new Image();
          img.src = url; // this will force browser to load image in background;
        });
      }, 50);
    }
  }, []);
  return null;
};

const mapStateToProps = (state: RootState) => ({
  urls: [
    ...state.quizState.quizImages.stepImages.map((el) => getBestThumbnail(el)),
    ...state.quizState.quizImages.optionImages.map((el) => getBestThumbnail(el, 'md')),
  ],
});

export default connect(mapStateToProps)(ImagesPreloader);
